import { Link, LinkProps } from '@mui/material';
import Iconify from 'src/components/iconify/iconify';

interface Props extends LinkProps {
  children?: React.ReactNode;
  icon?: string;
  iconSize?: number;
}

export default function CasLink2({ onClick, href, children, icon, iconSize = 16, ...rest }: Props) {
  return (
    <Link href={href} onClick={onClick} {...rest}>
      {icon && <Iconify icon={icon} width={iconSize} />}
      {children}
    </Link>
  );
}
